import api from "@/lib/api";

// CREATE
export const createRedirect = async (payload) => {
  const res = await api.post("/redirects/create", payload);
  return res.data;
};

// GET ALL
export const getAllRedirects = async () => {
  const res = await api.get("/redirects/all");
  return res.data;
};

// DELETE
export const deleteRedirect = async (redirect_id) => {
  const res = await api.post(`/redirects/delete/${redirect_id}`);
  return res.data;
};

// UPDATE (when backend is ready)
export const updateRedirect = async (payload) => {
  const res = await api.post("/redirects/update", payload);
  return res.data;
};